exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.anarchive-grid[data-v-475008f7] {\n    width: -moz-fit-content;\n    width: fit-content;\n    display: grid;\n}\n", ""]);

// exports
